// 같은 번들을 여러 웹루트에 배포하고 호스트로 화면을 가른다.
//   manager.klata.or.kr / dev-manager.klata.or.kr : 지역본부 관리자(전체 메뉴)
//   branch.klata.or.kr  / dev-branch.klata.or.kr  : 지역본부 현황 전용(2개 화면)
const hostname = () => (typeof window === 'undefined' ? '' : window.location.hostname);

export const isBranchSite = () => /^(dev-)?branch\./.test(hostname());

export const isDevSite = () => hostname().startsWith('dev-');

// 로그인 후 첫 화면
export const getHomePath = () => (isBranchSite() ? '/branch/place_stat' : '/testing_place/joins');
